module.exports = __webpack_public_path__ + "static/media/icon-pill-squash.ad408e30.svg";